/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

/* eslint-disable react/jsx-wrap-multilines */
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import uuid from 'uuid';
import parser from 'html-react-parser';
import BannerCTA from '../../components/banner/bannerCTA';
import './layout.scss';

const renderContent = ({
    appConfig,
    appsSkeletonModel,
    analytics,
    buttonList,
    borderColor,
    textList,
    textColor,
    imageList,
    name,
    onAction,
}) => {
    const { bannerAnalyticsCallback } = analytics;
    const style = { color: textColor };
    return (
        <div className="content-wrapper">
            <div className="card-body">
                <div className="card-body-title">
                    {imageList.map(imgSrc => <img alt="Product Icon" src={imgSrc} className="product-icon" />)}
                    <div className="plan-name" style={style}>{textList[0]}</div>
                </div>
                <div className="description" style={style}>{parser(textList[1])}</div>
            </div>
            <div
                className="card-action"
                style={{
                    borderTop: `0.0625rem solid
                        ${borderColor.length > 1 ? borderColor[1] : borderColor[0]}`,
                }}>
                {buttonList.map((buttonItem) => {
                    const guid = uuid.v4();
                    return <BannerCTA
                        buttonItem={buttonItem}
                        onAction={() => onAction(buttonItem.action, guid)}
                        style={style}
                        textColor={textColor}
                        bannerAnalyticsCallback={() => bannerAnalyticsCallback('bannerCTAClicked',
                            {
                                analytics: { ...analytics, guid, url: buttonItem.action.url },
                                CTAText: buttonItem.label,
                                ingestId: buttonItem.action.ingestId,
                                name,
                            }, appConfig, appsSkeletonModel)}

                    />;
                })}
            </div>
        </div>
    );
};

@observer
class CardBannerItemLayout extends Component {
    renderGuid = uuid.v4();

    componentDidMount() {
        const {
            bannerItem: {
                analytics, name, buttonList, ingestDescription,
            },
            appConfig,
            appsSkeletonModel,
        } = this.props;

        analytics.bannerAnalyticsCallback('bannerRendered', {
            analytics,
            CTAText: buttonList && buttonList[0].label,
            ingestId: buttonList && buttonList[0] && buttonList[0].action.ingestId,
            name,
            ingestDescription,
            renderGuid: this.renderGuid,
        }, appConfig, appsSkeletonModel);
    }

    render() {
        const {
            bannerItem, appConfig, appsSkeletonModel,
        } = this.props;
        const { backgroundColor, borderColor } = bannerItem;

        return (
            <div
                className="card-layout"
                render-guid={this.renderGuid}
                style={{ backgroundColor, border: `0.0625rem solid ${borderColor[0]}` }}>
                <div className="spacer-div" />
                {renderContent({
                    ...bannerItem, appConfig, appsSkeletonModel,
                })}
                <div className="spacer-div" />
            </div>
        );
    }
}

export default CardBannerItemLayout;
